import { apiCall } from "./apiClient";
import { ColorSchemeDto } from "../components/workShiftPlanning/utils/ShiftColors";

export const getColorScheme = async(
    scope: string = "workShiftPlanning",
    signal?: AbortSignal
) => {
    const response = await apiCall<ColorSchemeDto>(
        `UIColorScheme?scope=${encodeURIComponent(scope)}`,
        "GET",
        undefined,
        signal
    );
    return response.data;
};

export const saveColorScheme = async(dto: ColorSchemeDto) => {
    const response = await apiCall<ColorSchemeDto>(
        "UIColorScheme",
        "PUT",
        dto
    );
    return response.data;
};

export const resetColorScheme = async(scope: string = "workShiftPlanning") => {
    return await apiCall<void>(
        `UIColorScheme?scope=${encodeURIComponent(scope)}`,
        "DELETE"
    );
};